import Vue from 'vue'
import store from '../../store'
import firebase from 'firebase/app'

export default {
  namespaced: true,
  state () {
    return {
      routineSelf: [],
      reference: null
    }
  },
  getters: {
    routineSelf (state) {
      return state.routineSelf
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state) {
      state.routineSelf = []
    },
    add (state, payload) {
      state.routineSelf.push(payload)
    },
    update (state, payload) {
      const index = state.routineSelf.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        Vue.set(state.routineSelf, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.routineSelf.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        state.routineSelf.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      commit('init')
    },
    subscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var user = this.getters['authUser/user']
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var dbRef = db.collection('routine_self').doc(user.key).collection('data')
        var reference = dbRef.orderBy('createdAt', 'desc').onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            const payload = {
              key: change.doc.id,
              owner: change.doc.data().owner,
              title: change.doc.data().title,
              subTitle: change.doc.data().subTitle,
              done: change.doc.data().done,
              startAt: change.doc.data().startAt,
              endAt: change.doc.data().endAt,
              category: change.doc.data().category,
              share: change.doc.data().share,
              services: change.doc.data().services,
              createdAt: change.doc.data().createdAt,
              updatedAt: change.doc.data().updatedAt
            }
            var check = false
            for (var k in user.services) {
              if (user.services[k] && payload.services[k]) {
                check = true
              }
            }

            if (user.role === 'admin' || check) {
              if (change.type === 'added') {
                commit('add', JSON.parse(JSON.stringify(payload)))
              } else if (change.type === 'modified') {
                commit('update', JSON.parse(JSON.stringify(payload)))
              } else if (change.type === 'removed') {
                commit('remove', JSON.parse(JSON.stringify(payload)))
              }
            }
            resolve()
          })
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['routineSelf/reference']
      return new Promise((resolve, reject) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init')
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/RoutineSelf.js